import { localePath, buildSard, switchLocalePath } from '@/utils/i18nRoutes';

export const i18nRoutes = {
  defaultLanguages: {
    cz: 'cs',
    sk: 'sk',
    hu: 'hu'
  },
  install: function (Vue) {
    const defaultLanguages = this.defaultLanguages;

    Vue.mixin({
      computed: {
        $localePath() {
          return input => {
            const language = this.$i18n && this.$i18n.locale;
            const dl = defaultLanguages[this.$domainRegion];
            if (typeof input === 'string') {
              return localePath({ name: input, language, defaultLanguage: dl });
            }
            if (input?.defaultLanguage) {
              return localePath({ ...input, language: input.defaultLanguage });
            }

            if (input?.language) {
              return localePath({ ...input, defaultLanguage: dl });
            }

            return localePath({ ...input, language, defaultLanguage: dl });
          };
        }
      },
      methods: {
        $switchLocalePath(language = this.$i18n.locale) {
          return switchLocalePath({
            route: this.$route,
            language,
            defaultLanguage: defaultLanguages[Vue.prototype.$domainRegion]
          });
        }
      }
    });

    Vue.prototype.$buildSard = buildSard;
  }
};
